import { render, staticRenderFns } from "./IFInsightspdf.vue?vue&type=template&id=7265dfa6"
import script from "./IFInsightspdf.vue?vue&type=script&lang=js"
export * from "./IFInsightspdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports